import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InstallmentPayments = /*#__PURE__*/function () {
  function InstallmentPayments() {
    _classCallCheck(this, InstallmentPayments);
  }
  return _createClass(InstallmentPayments, [{
    key: "installment0ney",
    value: function installment0ney(buttonElt) {
      if (!buttonElt) {
        return;
      }
      buttonElt.addEventListener('click', function (evt) {
        var dataSets = evt.target.dataset;
        if (!dataSets.scripturl) {
          return;
        }
        try {
          var options = {
            country: dataSets.country,
            language: dataSets.language,
            merchant_guid: dataSets.merchantguid,
            payment_amount: dataSets.paymentamount,
            filter_by: dataSets.filterby,
            business_transaction_codes: dataSets.businesstransactioncodes.split(','),
            merchant_name: dataSets.merchantname,
            oney_bnpl_link: dataSets.bnpllink,
            exclusivity_type: dataSets.exclusivitytype,
            credit_intermediary_category: dataSets.creditintermediarycategory
          };
          if (window.oneyMerchantApp) {
            loadOneyPopin(options);
          } else {
            appendJsScript(dataSets.scripturl, function () {
              loadOneyPopin(options);
            });
          }
        } catch (error) {
          throw new Error(error);
        }
      });
    }
  }, {
    key: "installmentPaypal",
    value: function installmentPaypal(buttonElt) {
      var _this = this;
      if (!buttonElt) {
        return;
      }
      this.loadScriptPaypal = false;
      buttonElt.addEventListener('click', function (evt) {
        var dataSets = evt.target.dataset;
        if (!dataSets.scripturl) {
          return;
        }
        try {
          if (!_this.loadScriptPaypal) {
            appendJsScript(dataSets.scripturl, function () {
              _this.modal = paypal.MessagesModal({
                "buyerCountry": dataSets.buyerCountry,
                "amount": dataSets.paymentamount,
                onReady: function onReady(_ref) {
                  var show = _ref.show,
                    hide = _ref.hide;
                  show();
                }
              });
              _this.modal.render(buttonElt);
              _this.loadScriptPaypal = true;
            });
          } else {
            _this.modal.show();
          }
        } catch (error) {
          throw new Error(error);
        }
      });
    }
  }]);
}();
export { InstallmentPayments as default };
function loadOneyPopin(options) {
  loadOneyWidget(function () {
    oneyMerchantApp.loadSimulationPopin({
      options: options
    });
  });
}
function appendJsScript(url, callback) {
  var script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = callback;
  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
}